export const INPUT_CARD_EXPIRATION_MASK = [/\d/, /\d/, '/', /\d/, /\d/]
